export const logFeatureEngaged = (name: string, category: string): void => {
  if (typeof window === 'undefined') return;

  import('@netflix/nfa-logger/lib/helper')
    .then(({ nfa }) => {
      nfa.logFeatureEngaged(name, category);
    })
    .catch(() => {
      // Intentionally swallowed — analytics must not break the UI.
    });
};
